import api from './api';

export interface SalesMetrics {
  totalRevenue: number;
  totalOrders: number;
  averageOrderValue: number;
  pendingOrders: number;
  revenueGrowth: number;
  ordersGrowth: number;
}

export interface SalesChartData {
  date: string;
  revenue: number;
  orders: number;
}

export interface TopProduct {
  id: string;
  product_id: string;
  name: string;
  variant: string;
  sku: string;
  quantity: number;
  revenue: number;
}

export interface SalesPipeline {
  estimates: number;
  salesOrders: number;
  invoices: number;
  convertedEstimates: number;
  invoicedOrders: number;
  estimateToOrderRate: number;
  orderToInvoiceRate: number;
  outstandingAmount: number;
  collectedAmount: number;
}

export interface TopCustomer {
  id: string;
  name: string;
  totalOrders: number;
  totalRevenue: number;
}

export interface OrderStatusBreakdown {
  status: string;
  count: number;
  percentage: number;
}

export interface SalesDashboardData {
  metrics: SalesMetrics;
  revenueChart: SalesChartData[];
  topProducts: TopProduct[];
  topCustomers: TopCustomer[];
  orderStatusBreakdown: OrderStatusBreakdown[];
  pipeline: SalesPipeline;
  recentOrders: any[];
}

const salesDashboardService = {
  getDashboardData: async (period: string = '30d', dateFrom?: string, dateTo?: string): Promise<SalesDashboardData> => {
    const response = await api.get('/admin/analytics/sales/dashboard', {
      params: { period, date_from: dateFrom, date_to: dateTo }
    });
    return response.data;
  },

  getMetrics: async (period: string = '30d'): Promise<SalesMetrics> => {
    const response = await api.get('/admin/analytics/sales/metrics', {
      params: { period }
    });
    return response.data;
  },

  getRevenueChart: async (period: string = '30d'): Promise<SalesChartData[]> => {
    const response = await api.get('/admin/analytics/sales/revenue-chart', {
      params: { period }
    });
    return response.data;
  },

  getTopProducts: async (limit: number = 5): Promise<TopProduct[]> => {
    const response = await api.get('/admin/analytics/sales/top-products', {
      params: { limit }
    });
    return response.data;
  },

  getTopCustomers: async (limit: number = 5): Promise<TopCustomer[]> => {
    const response = await api.get('/admin/analytics/sales/top-customers', {
      params: { limit }
    });
    return response.data;
  },

  getOrderStatusBreakdown: async (): Promise<OrderStatusBreakdown[]> => {
    const response = await api.get('/admin/analytics/sales/order-status');
    return response.data;
  }
};

export default salesDashboardService;
